// extracted by mini-css-extract-plugin
module.exports = {"container":"searchDublication_container__3_zNy"};